import lodash from 'lodash'
import React, { useEffect } from 'react'
import { ReactElement } from 'react'

import {
  Col,
  FormRow,
} from '../../../../../../1stlog-ui/src/components/Bootstrap'
import { FeedbackBadge } from '../../../../../../1stlog-ui/src/components/Field'
import useFieldRaw from '../../../../../../1stlog-ui/src/components/Field/useFieldRaw'
import useFieldValue from '../../../../../../1stlog-ui/src/components/Field/useFieldValue'
import { SimpleValidate } from '../../../../../../1stlog-ui/src/components/Field/Validation'
import { TOrderEntryColi } from '../../../types'

const validate = SimpleValidate

const DuplicateBarcodesValidation = (): ReactElement => {
  const colis = useFieldValue<TOrderEntryColi[]>('colis')

  const {
    input: {
      value: isUniqueBarcodesInvalid,
      onChange: setIsUniqueBarcodesInvalid,
    },
    meta,
  } = useFieldRaw<string | null>('validation.isUniqueBarcodesInvalid', {
    validate,
    subscribeAll: true,
  })

  useEffect(() => {
    const duplicates = lodash.first(
      lodash.keys(
        lodash.pickBy(
          lodash.groupBy(lodash.map(colis, (coli) => coli?.barcode1)),
          (v) => lodash.size(v) > 1,
        ),
      ),
    )

    setIsUniqueBarcodesInvalid(
      duplicates && duplicates !== 'undefined'
        ? i18n.t('validation_duplicate_barcode', {
            defaultValue:
              'Der Barcode {{barcode}} darf nicht mehrfach verwendet werden.',
            barcode: duplicates,
          })
        : undefined,
    )
  }, [colis])

  return isUniqueBarcodesInvalid ? (
    <FormRow>
      <Col>
        <FeedbackBadge meta={meta} />
      </Col>
    </FormRow>
  ) : (
    <></>
  )
}

export default DuplicateBarcodesValidation
